import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';
import { useTheme } from '@hivebrite/design-system/Theme';

const ThumbnailLoader = () => {
  const theme = useTheme();

  return (
    <Card px={0} py={0} width="100%" height="100%">
      <Box display="block">
        <Box>
          <Skeleton
            height={175}
            width="100%"
            css={`
              border-radius: ${theme.themeVariables.globalBorderRadius}px
                ${theme.themeVariables.globalBorderRadius}px 0 0;
            `}
          />
        </Box>

        <Box display="block" mt="14px" px={4} pb={6}>
          <Skeleton height={48} width="100%" />

          <Skeleton height={34} width="100%" mt={2} />
        </Box>
      </Box>
    </Card>
  );
};

export default ThumbnailLoader;
